<template>
  <modal v-model="isVisible" size="sm" data-dismiss="modal">
    <form id="sync-order" @submit.prevent="onSubmit">
      <div class="c-modalCard">
        <header class="c-modalCard__header">
          <i class="icon-sync icon-download2"/>
          <h4 class="c-modalCard__title">Sincronizar pedido</h4>
          <a role="button" class="c-modalCard__close" v-on:click="close">
            <i class="i-remove"></i>
          </a>
        </header>
        <div class="c-modalCard__body">
          <div v-if="syncErrorMsg" class="l-row">
            <div class="l-col-12">
              <h5><span class="c-alert--danger">Erro</span></h5>
              {{ syncErrorMsg }}
              <br><br>
            </div>
          </div>
          <div class="l-row">
            <form-group :columns="6" label="Marketplace">
              <select class="form-select" id="identifier" v-model="identifier" @change="onIdentifierChange">
                <option value="">Selecione</option>
                <option v-for="marketplace in definitionMarketplacesInstalled" :key="marketplace.identifier" :value="marketplace.identifier">
                  {{ marketplace.name }}
                </option>
              </select>
            </form-group>

            <form-group :columns="6" label="Identificador do pedido">
              <input autofocus type="text" class="form-input" id="code" v-model="code">
            </form-group>

            <component v-if="hasCustomSyncDialog" :is="customSyncDialog" ref="customSyncDialog"/>
          </div>
        </div>
        <footer class="c-modalCard__footer">
          <button type="button" class="btn btn--default" @click="close">Fechar</button>
          <button v-bind:class="{ 'is-loading': syncing }" :disabled="!canSync || syncing" type="submit" class="btn btn--primary">Sincronizar</button>
        </footer>
      </div>
    </form>
  </modal>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { upperFirst } from 'lodash'
  import notifier from '@/notifier'
  import FormGroup from '@/components/template/FormGroup'
  import SyncDialogMercadoLivre from '@/components/marketplace/mercadoLivre/order/SyncDialog'
  import SyncDialogShopee from '@/components/marketplace/shopee/order/SyncDialog'
  import SyncDialogAmazon from '@/components/marketplace/amazon/order/SyncDialog'
  import SyncDialogTikTokShop from '@/components/marketplace/tiktokshop/order/SyncDialog'
  import SyncDialogShein from '@/components/marketplace/shein/order/SyncDialog'
  import SyncDialogMagalu from '@/components/marketplace/magalu/order/SyncDialog'

  export default {
    data: () => ({
      isVisible: false,
      syncing: false,
      identifier: '',
      code: '',
      modal: null,
      syncErrorMsg: null,
      hasCustomSyncDialog: false
    }),
    created () {
      this.isVisible = this.value
    },
    mounted () {
      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      ...mapActions('orders', [
        'syncOrder'
      ]),
      onIdentifierChange () {
        this.hasCustomSyncDialog = false

        if (this.identifier === 'mercadoLivre' || this.identifier === 'shopee' || this.identifier === 'amazon' || this.identifier === 'tikTokShop' || this.identifier === 'shein' || this.identifier === 'magalu') {
          this.hasCustomSyncDialog = true
        }
      },
      close () {
        delete document.body.onkeyup
        delete this.modal.onclick
        this.isVisible = false
      },
      clearFields () {
        this.identifier = ''
        this.code = ''
      },
      async onSubmit () {
        this.syncing = true

        try {
          let data = {
            type: 'marketplace',
            identifier: this.identifier,
            code: this.code
          }

          if (this.hasCustomSyncDialog) {
            await this.$refs.customSyncDialog.syncOrder(data)
          } else {
            await this.syncOrder(data)
          }

          this.clearFields()
          this.close()
          notifier.success('Pedido sincronizado com sucesso!', 'Sincronizado')
          this.syncErrorMsg = null
        } catch (err) {
          if (err.response.data !== undefined && err.response.data.message !== undefined && err.response.status === 404) {
            this.syncErrorMsg = err.response.data.message
          }
          if (err.response.data.message === 'order_not_found') {
            notifier.error('Pedido ' + this.code + ' não encontrado no Marketplace', 'Erro')
          } else {
            notifier.error('Não foi possível sincronizar o pedido!', 'Erro')
          }
        }
        this.syncing = false
      }
    },
    computed: {
      ...mapGetters('module', [
        'definitionMarketplacesInstalled'
      ]),
      canSync () {
        return !!this.identifier.length && !!this.code.length
      },
      customSyncDialog () {
        return `SyncDialog${upperFirst(this.identifier)}`
      }
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    },
    props: {
      value: {
        type: Boolean,
        required: true
      }
    },
    components: {
      FormGroup,
      SyncDialogMercadoLivre,
      SyncDialogShopee,
      SyncDialogAmazon,
      SyncDialogTikTokShop,
      SyncDialogShein,
      SyncDialogMagalu
    }
  }
</script>

<style lang="sass" scoped>
  h4
    margin-left: 7px
</style>




// WEBPACK FOOTER //
// SyncDialog.vue?3ee58938